import { computed, ref } from 'vue';

export default (props, emit) => {
  const favorisIsIn = computed(() => {
    const cartId = props.cardData.uuid;
    const LstFavId = props.listResFav;
    return !!(LstFavId || []).find((itemFav) => itemFav.key === cartId);
  });
  const isFavBtnClicked = ref(false);
  const isActiveCard = computed(() => props.isConnected && favorisIsIn.value);

  function favorisClass() {
    let classFav = 'favourite-link ajax-favorites tip-icon only-desktop open-login  popover-init-js';
    if (props.isConnected && favorisIsIn.value) {
      classFav = 'favourite-link ajax-favorites tip-icon only-desktop active popover-init-js';
    } else if (props.isConnected) {
      classFav = 'favourite-link ajax-favorites tip-icon only-desktop popover-init-js IsConnected ';
    }
    return classFav;
  }
  function favorisStarClass() {
    if (props.isConnected && favorisIsIn.value) {
      return 'full';
    }
    return 'empty';
  }

  function favorisClick() {
    const cartId = props.cardData.uuid;
    isFavBtnClicked.value = !isFavBtnClicked.value;
    emit('favorisMajComponentType', { id: cartId, isFavBtnClicked: favorisIsIn.value });
  }

  return {
    favorisClass,
    favorisClick,
    favorisIsIn,
    isFavBtnClicked,
    isActiveCard,
    favorisStarClass,
  };
};
